export const DeliveryAllocationsResource = {
  name: "Delivery Allocations",
  path: "/fleets/delivery-allocations",
  access: ["read-deliveryAllocations"],
};
